import React, { useState } from 'react'
import styled from 'styled-components'
import { STYLES } from '../../static/style'
import { CaretRightIcon } from '../../components/Icon/CaretRightIcon'
import { CaretDownIcon } from '../../components/Icon/CaretDownIcon'
import { Text } from '../../components/Text'

const StyledDeveloperFilter = styled.div`
  margin-top: 0.5rem;
  width: 100%;
  padding-left: 0 !important;
`

const LabelHeader = styled.div`
  margin-bottom: ${STYLES.GUTTER};
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
`

const LabelHeaderText = styled(Text)`
  margin-left: ${STYLES.GUTTER};
`

const ContentContainer = styled.div`
  margin-left: 1.5rem;
`

interface IDeveloperFilterProps {
  labelHeader: string
  children: React.ReactNode
  isCollapsible?: boolean
}

const DeveloperFilter: React.FC<IDeveloperFilterProps> = ({
  labelHeader,
  children,
  isCollapsible = true,
}) => {
  const [isExpanded, setIsExpanded] = useState(false)
  return (
    <StyledDeveloperFilter>
      <LabelHeader
        onClick={() => {
          setIsExpanded(!isExpanded)
        }}
      >
        {isCollapsible && !isExpanded && <CaretRightIcon />}
        {isCollapsible && isExpanded && <CaretDownIcon />}
        <LabelHeaderText>{labelHeader}</LabelHeaderText>
      </LabelHeader>
      {((isCollapsible && isExpanded) || isCollapsible === false) && (
        <ContentContainer>{children}</ContentContainer>
      )}
    </StyledDeveloperFilter>
  )
}

export { DeveloperFilter }
